import { lazy } from 'react';

import Loadable from 'components/Loadable';

const Demo = Loadable(lazy(() => import('modules/enrollment')));

export const route = {
  path: 'recognition/enrollment/:account',
  element: <Demo />,
};
